import { StorageLocationType } from "@redotech/cockroachdb-codegen/tables/fulfillment/storage-location-type";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const CycleCountBinSchema = z.object({
  storageLocationId: storageLocationIdFormat.schema,
  binName: z.string(),
  /** storage_location.type, for display. Countable bins are bin or storage. */
  binType: createEnum(StorageLocationType),
  /**
   * Oldest last_counted_at across the bin's levels, or null when any of them
   * has never been counted — a never-counted level is older than any date.
   */
  lastCountedAt: z.date().nullable(),
});
export type CycleCountBin = z.infer<typeof CycleCountBinSchema>;

/**
 * Bulk-resolves countable bins by name prefix or exact names, unlike searchBins
 * which is a small capped typeahead over any matching substring.
 */
export const resolveCycleCountBins = {
  name: "resolveCycleCountBins" as const,
  input: z.object({
    locationId: locationIdFormat.schema,
    /** Bins whose name starts with this. */
    prefix: z.string().nullish(),
    /** Bins with exactly these names, e.g. the bins a chosen rack generates. */
    names: z.array(z.string()).nullish(),
  }),
  output: z.object({
    bins: z.array(CycleCountBinSchema),
    /** More bins matched than the response carries. */
    truncated: z.boolean(),
  }),
};
